import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    IDownloadProductListCancelAction,
    IDownloadProductListErrorAction,
    IDownloadProductListStartAction,
    IDownloadProductListSuccessAction,
} from '../actions/download-product-list';
import { IOrderTrackerState } from '../state';
import { initialState } from '../state/initial-state';

export type DownloadProductListAction =
    | IDownloadProductListStartAction
    | IDownloadProductListSuccessAction
    | IDownloadProductListErrorAction
    | IDownloadProductListCancelAction;

const init = (
    state: IOrderTrackerState,
    action: DownloadProductListAction
): IOrderTrackerState => {
    return {
        ...state,
        productListDownload: {
            ...initialState.productListDownload,
            status: action.status,
            fileType: (action as IDownloadProductListStartAction).fileType,
        },
    };
};

const success = (
    state: IOrderTrackerState,
    action: DownloadProductListAction
): IOrderTrackerState => {
    return {
        ...state,
        productListDownload: {
            ...initialState.productListDownload,
            status: action.status,
            fileType: (action as IDownloadProductListSuccessAction).fileType,
        },
    };
};

const failure = (
    state: IOrderTrackerState,
    action: DownloadProductListAction
): IOrderTrackerState => {
    return {
        ...state,
        productListDownload: {
            ...state.productListDownload,
            status: action.status,
            error: (action as IDownloadProductListErrorAction).error,
        },
    };
};

const reset = (
    state: IOrderTrackerState,
    action: DownloadProductListAction
): IOrderTrackerState => {
    return {
        ...state,
        productListDownload: {
            ...initialState.productListDownload,
            status: action.status,
        },
    };
};

export const downloadProductListReducer = createAsyncReducer(
    initialState,
    init,
    success,
    failure,
    reset
);
